<div class="vertical-button-panel">

  <button mat-stroked-button color="primary" mat-button type='button' (click)="toEdit()"
      angulartics2On="click" 
      angularticsAction="EditClick"
      [angularticsCategory]="'' + item.id">
    <mat-icon fontSet="material-symbols-outlined">edit_note</mat-icon>
    <ng-container i18n>EDIT</ng-container>
  </button>

  <universal-share-button 
      [url]="getItemURL()" 
      [analyticsCategory]="'' + item.id" 
      [title]="item.title" 
      type="secondary"
      [description]="item.description">
  </universal-share-button>

  <button mat-stroked-button color="primary" mat-button type='button' (click)="removeListing()"
      angulartics2On="click" 
      angularticsAction="RemoveListingClick"
      [angularticsCategory]="'' + item.id">
    <mat-icon fontSet="material-symbols-outlined">remove</mat-icon>
    <ng-container i18n>UNLIST</ng-container>
  </button>

</div>